import {
  CircularProgress,
  Collapse,
  Table, TableBody, TableCell,
  TableHead,
  TableRow,
  Typography
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import {makeStyles} from "@material-ui/styles";
import {ExpandLess, ExpandMore } from "@material-ui/icons";
import EntityOwnerDataRow from "../acordionRows/EntityOwnerDataRow";
import axios from 'axios';

const useStyles = makeStyles((theme) => ({
  contentSection: {
    padding: '16px 22px',
    background: '#eeeeee',
    marginBottom: '15px',
    borderRadius: '3px',
  },
  contentSectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer'
  },
  contentSectionHeaderTitle: {
    fontSize: '17px',
    fontWeight: '600',
    color: '#000',
  },
  contentSectionContent: {

  },
  formGroup: {
    padding: theme.spacing(2, 0)
  },
  form: {
    height: '100%',
  },
  field: {
    '& label.Mui-focused': {
      color: '#000',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#000',
    },
    '& .MuiOutlinedInput-root': {
      '&:hover fieldset': {
        borderColor: '#000',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#000',
      },
    },
  },
  tabActive: {
    color: '#1E69E5',
  },
  associationLink: {
    position: 'absolute',
    top: '-10px',
    right: '10px',
    cursor: 'pointer',
    decoration: 'none',
    '&:hover': {
      decoration: 'none',
    }
  },
  inheritFontWeight: {
    fontWeight: 'inherit',
  },
  tableMarginTop: {
    marginTop: 24,
  },
}));

const OwnerExecutiveOfficer = (props) => {
  const classes = useStyles();

  const [entityOwners, setEntityOwners] = useState([]);
  const [status, setStatus] = useState('fetching');

  const {
    contactId,
    handleTabChange,
    tab,
    adminUserSession,
  } = props;

  useEffect(() => {
    axios.get(
      `/v1/admin/ria_contacts/${contactId}/entity_owners`,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          'X-Admin-User-Email': adminUserSession.email,
          'X-Admin-User-Token': adminUserSession.token
        }
      }
    ).then((response) => {
      const { entity_owners, status } = response.data;

      setEntityOwners(entity_owners);
      setStatus(status);
    });
  }, []);

  return (
    <div className={classes.contentSection}>
      <div className={classes.contentSectionHeader} onClick={(event) => handleTabChange(event, 10)}>
        <Typography variant='h5' className={`${classes.contentSectionHeaderTitle} ${tab === 10 ? classes.tabActive : ''}`}>Owner/Executive Officer Info</Typography>
        {status !== 'fetched' ? <CircularProgress /> : ''}
        {tab === 10 ? <ExpandLess /> : <ExpandMore />}
      </div>
      <Collapse in={tab === 10}>
        <div className={classes.contentSectionContent}>
          <div className={classes.formGroup}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell className={classes.inheritFontWeight}>Entity CRD Id</TableCell>
                  <TableCell className={classes.inheritFontWeight}>Owner Type</TableCell>
                  <TableCell className={classes.inheritFontWeight}>Contact Status</TableCell>
                  <TableCell className={classes.inheritFontWeight}>Month</TableCell>
                  <TableCell className={classes.inheritFontWeight}>Year</TableCell>
                  <TableCell className={classes.inheritFontWeight}>Ownership Code</TableCell>
                  <TableCell className={classes.inheritFontWeight}>Ownership Perecentage</TableCell>
                  <TableCell className={classes.inheritFontWeight}>Control Person</TableCell>
                  <TableCell className={classes.inheritFontWeight}>Owner a Public Company</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <EntityOwnerDataRow entityOwners={entityOwners}/>
              </TableBody>
            </Table>
          </div>
        </div>
      </Collapse>
    </div>
  )
}

export default OwnerExecutiveOfficer;